import { render } from "./Instructors.vue?vue&type=template&id=f941f1a0"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__